import PropTypes from 'prop-types';
import React from 'react';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import LinkToModuleResource from '../../../common/resource/LinkToModuleResource';
import { CABIN_CREW_PATH } from '../../../../config/paths';
import { tzNormalizeDate } from '../../../../utils/date';
import { DATE_TIME_FORMAT } from '../../../../config/locale';

const CabinCrewMovementHistoryBasicResource = ({
  id,
  cabinCrewFullName,
  startDate,
  endDate,
  cabinCrewMovementName,
  note,
  secondaryNote,
  cabinCrewId,
  chargeYear,
  chargeMonth
}) => {
  const calculateDaysDifference = (startTimestamp, endTimestamp) => {
    const start = new Date(startTimestamp);
    const end = new Date(endTimestamp);
    const startDay = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    const endDay = new Date(end.getFullYear(), end.getMonth(), end.getDate());
    const diffTime = endDay - startDay;
    const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));
    return diffDays + 1;
  };

  const missingDays = (startTimestamp, endTimestamp) => {
    const start = new Date(startTimestamp);
    const end = new Date(endTimestamp);
    const currentDate = new Date();

    if (currentDate > end) {
      return 0;
    }

    const startDay = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    const currentDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const diffTime = currentDay - startDay;
    const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));
    const totalDays = calculateDaysDifference(startTimestamp, endTimestamp);
    return Math.max(0, totalDays - diffDays - 1);
  };

  const chargeDateLabel = () => {
    if (chargeYear && chargeMonth) {
      return `${chargeMonth}/${chargeYear}`;
    }
    return null
  };

  return (
    <>
      <ResourceProperty label="Id:">{id}</ResourceProperty>
      <ResourceProperty label="Servicio a Bordo:">
        <LinkToModuleResource
          text={cabinCrewFullName}
          href={`${CABIN_CREW_PATH}/${cabinCrewId}`}
          isExternalPath
        />
      </ResourceProperty>
      <ResourceProperty label="Motivo:">{cabinCrewMovementName}</ResourceProperty>
      <ResourceProperty label="Fecha/Hora Inicio:">
        {tzNormalizeDate({ date: startDate, format: DATE_TIME_FORMAT })}
      </ResourceProperty>
      <ResourceProperty label="Fecha/Hora Final:">
        {tzNormalizeDate({ date: endDate, format: DATE_TIME_FORMAT })}
      </ResourceProperty>
      <ResourceProperty label="Días Asignados:">
        {calculateDaysDifference(startDate, endDate)}
      </ResourceProperty>
      <ResourceProperty label="Días Faltantes:">
        {missingDays(startDate, endDate)}
      </ResourceProperty>
      <ResourceProperty label="Observación 1:">{note}</ResourceProperty>
      <ResourceProperty label="Observación 2:">
        {secondaryNote}
      </ResourceProperty>
      {chargeYear && chargeMonth && (
        <ResourceProperty label="Fecha de Cobro:">{chargeDateLabel()}</ResourceProperty>
      )}
    </>
  );
};

CabinCrewMovementHistoryBasicResource.propTypes = {
  id: PropTypes.number.isRequired,
  cabinCrewFullName: PropTypes.string.isRequired,
  startDate: PropTypes.number.isRequired,
  endDate: PropTypes.number.isRequired,
  cabinCrewMovementName: PropTypes.string.isRequired,
  note: PropTypes.string,
  secondaryNote: PropTypes.string,
  cabinCrewId: PropTypes.number.isRequired,
  chargeYear: PropTypes.number,
  chargeMonth: PropTypes.number,
};

CabinCrewMovementHistoryBasicResource.defaultProps = {
  note: '',
  secondaryNote: '',
  chargeYear: null,
  chargeMonth: null,
};

export default CabinCrewMovementHistoryBasicResource;